export class outboundCamp {

    constructor(outboundCampJson) {
        this.camdId             = outboundCampJson.ID;
        this.campName           = outboundCampJson.Description;
        this.rotativeManual     = outboundCampJson.SelectRotativeAniManualCall;
        this.campType           = outboundCampJson.Camptype;
        this.defaultCamp        = outboundCampJson.Default;
        this.frame              = outboundCampJson.GraphicID
    }

}